<template>
  <font-awesome-icon class="person-icon" icon="user"></font-awesome-icon>
</template>
